export default "__VITE_ASSET__hqFKzuyV__"